// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TestimonialList-module--wrapper--3xK7k","testimonial":"TestimonialList-module--testimonial--208ij"};